
<template>
  <div class="chart_box"
       id="insuranceTendChart"></div>

</template>
<script>

export default {
  name: 'InsuranceTend',
  props: {
    // dataset: {
    //   type: Object,
    //   default: () => ({
    //     dimensions: ['year', '物化成本', '完全成本', '收入险', '价格险'],
    //     source: [
    //       { 'year': '2010', '物化成本': 200, '完全成本': 500, '收入险': 80, '价格险': 199 },
    //       { 'year': '2011', '物化成本': 200, '完全成本': 30, '收入险': 800, '价格险': 200 },
    //       { 'year': '2012', '物化成本': 200, '完全成本': 30, '收入险': 40, '价格险': 293 },
    //       { 'year': '2013', '物化成本': 560, '完全成本': 440, '收入险': 330, '价格险': 350 }
    //     ]

    //   })

    // }
  },
  data () {
    return {
      chart: null,
      dataset: {
        // dimensions: ['year', '物化成本', '完全成本', '收入险', '价格险'],
        dimensions: ['year', '物化成本', '完全成本'],
        source: [
        //   { 'year': '2010', '物化成本': 200, '完全成本': 500, '收入险': 80, '价格险': 199 },
        //   { 'year': '2011', '物化成本': 200, '完全成本': 30, '收入险': 800, '价格险': 200 },
        //   { 'year': '2012', '物化成本': 200, '完全成本': 30, '收入险': 40, '价格险': 293 },
        //   { 'year': '2013', '物化成本': 560, '完全成本': 440, '收入险': 330, '价格险': 350 }
        ]

      }
    }
  },
  mounted () {
    this.chart = this.$echarts.init(document.getElementById('insuranceTendChart'))
    window.addEventListener('resize', () => {
      this.chart.resize()
    })
    this.initData()
  },
  methods: {

    initData () {
      this.initChart()
    },
    initChart () {
      let option = {
        title: {
          text: '各种险种承保趋势',
          top: 10,
          left: 20,
          textStyle: {
            color: '#fff',
            fontSize: 15,
            fontWeight: 'normal'

          }

        },
        // tooltip: {
        //   trigger: 'axis'
        // },
        tooltip: {
          // triggerOn: 'click',
          trigger: 'item',
          backgroundColor: '#103164',
          borderColor: '#2a69c6',
          className: 'custom_tooltip_box',
          // formatter: '{b}<br />面积占比：{d}%',
          position: function (point) {
            return [point[0] + 10, point[1] - 80]
          },
          formatter: function (params) {
            console.log('params:', params.data)

            if (params.name) {
              return `<div class='custom_tooltip_style'>
            <div class='custom_tooltip_inner'>${params.name}<br />${params.seriesName}：${params.data[params.seriesName]}万亩</div>

            </div>`
            }

            // return '{b}<br />面积占比：{d}%'
          },
          padding: [4, 20, 5, 10],
          textStyle: {
            color: '#91b9f6'
          },
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },

        // legend: {
        //   data: ['物化成本', '完全成本', '收入险', '价格险'],
        //   top: 40
        // },
        legend: {
          // data: ['物化成本', '完全成本', '收入险', '价格险'],
          icon: 'rect',
          top: '18%',
          right: '1%',

          itemGap: 10,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#c6e1fc',
            fontSize: 12,
            // fontWeight: 'bold',
            padding: 4
          }
        },
        dataset: this.dataset,
        color: ['#1D42E5', '#05C9D0', '#F8AF30', '#1598FF'],
        grid: {
          top: '30%',
          left: '5%',
          right: '6%',
          bottom: '4%',
          containLabel: true
        },

        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: { show: false },

          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#ADADAD',
              fontSize: 12
            }

          }

        // data: ['物化成本', '完全成本', '收入险', '价格险'],
        },
        yAxis: {
          name: '万亩',
          nameTextStyle: {
            color: '#b0aeaf',
            fontSize: 14,
            margin: 10
          },
          type: 'value',
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.3)',
              type: 'dashed'
            }

          },
          axisLabel: {
            textStyle: {
              color: '#ADADAD',
              fontSize: 14
            }

          }

        },

        series: [
          {
            name: '物化成本',
            type: 'line',
            stack: 'Total',
            symbol: false
            // data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '完全成本',
            type: 'line',
            stack: 'Total',
            symbol: false
            // data: [220, 182, 191, 234, 290, 330, 310]
          }
          // {
          //   name: '收入险',
          //   type: 'line',
          //   stack: 'Total',
          //   symbol: false
          //   // data: [150, 232, 201, 154, 190, 330, 410]
          // },
          // {
          //   name: '价格险',
          //   type: 'line',
          //   stack: 'Total',
          //   symbol: false
          //   // data: [320, 332, 301, 334, 390, 330, 320]
          // }

        ]
      }

      this.chart.setOption(option, true)
    }
  },
  watch: {
    dataset: {

      handler (val) {
        if (val) {
          this.initData()
        }
      },
      deep: true
    }

  }
}
</script>
<style lang="less" scoped>
.chart_box {
  width: 100%;
  height: 100%;
}
/deep/.custom_tooltip_box {
  padding: 0 !important;
  border: none !important;
  background-color: transparent !important;
  height: auto !important;
  box-shadow: none !important;
  .custom_tooltip_style {
    line-height: 24px;
    padding: 4px 10px 5px;
    border: 1px solid #2a69c6;
    border-radius: 4px;
    background: #103164;
    color: #c6e1fc;
  }
  .custom_tooltip_item {
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/components/v1/InsuranceTend/index.vue